import { SVGProps, Ref, forwardRef, memo } from 'react';

const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg width={18} height={18} fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
    <path
      className="flag"
      d="M3.414 7.663c.17 1.084 1.404 1.945 2.93 1.998 1.055.036 2.132.055 3.301.055 1.17 0 2.247-.019 3.302-.055 1.526-.053 2.76-.914 2.93-1.998.115-.73.209-1.478.209-2.24 0-.763-.094-1.512-.209-2.242-.17-1.084-1.404-1.945-2.93-1.997a95.137 95.137 0 0 0-3.302-.055c-1.169 0-2.246.019-3.301.055-1.526.052-2.76.913-2.93 1.997-.115.73-.209 1.479-.209 2.241 0 .763.094 1.511.209 2.241Z"
      fill="#fff"
      stroke="#070F21"
    />
    <path className="mast" d="M3.205 1.129v15.743" stroke="#070F21" strokeLinecap="round" />
    <path className="dot" d="M9.647 6.707a1.286 1.286 0 1 0 0-2.571 1.286 1.286 0 0 0 0 2.571Z" fill="#070F21" />
  </svg>
);

const ForwardRef = forwardRef(SvgComponent);
const CountriesIcon = memo(ForwardRef);
export default CountriesIcon;
